export default function getFieldValues(data) {
  const fields = [];
  function recursiveSearch(innerObj) {
    if (typeof innerObj === 'object' && innerObj !== null) {
      Object.entries(innerObj).forEach(([k, v]: any) => {
        if (k === 'value') {
          if (typeof v === 'object') {
            recursiveSearch(v.args);
          } else {
            fields.push(v);
          }
        } else {
          recursiveSearch(v);
        }
      });
    }
  }

  function traverse(node) {
    if (node?.type === 'rule' && node?.properties?.field) {
      if (node.properties.field.args) {
        recursiveSearch(node.properties.field.args);
      } else {
        fields.push(node.properties.field);
      }
    } else if (node?.type === 'group' && Array.isArray(node.children1)) {
      node.children1.forEach((child) => traverse(child));
    }
  }

  function processCaseItem(caseItem) {
    if (caseItem?.when) traverse(caseItem.when);
    if (caseItem?.thenQuery) traverse(caseItem.thenQuery);
  }

  if (data?.caseList && Array.isArray(data?.caseList)) {
    data?.caseList.forEach(processCaseItem);
  }

  if (data?.query) traverse(data.query);
  if (data?.elseQuery) traverse(data.elseQuery);

  return fields;
}
